import { createRoot } from 'react-dom/client';
import { loadRuntimeConfig } from './runtime-config';
import { AppLoaderPage } from './components/AppLoaderPage';
import { reloadOnStaleChunk } from './utility/staleChunkReload';

export async function bootstrap(rootElId: string, app: React.JSX.Element) {
  reloadOnStaleChunk();
  const reactRootEl = createRoot(document.getElementById(rootElId)!);

  try {
    reactRootEl.render(<AppLoaderPage />);
    await loadRuntimeConfig();
    reactRootEl.render(app);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    reactRootEl.render(<AppLoaderPage error />);
    // If config fails to load, route to a static maintenance page
    // temporary navigate to GoKlaim maintenance page
    // @todo replace with gohr maintenance page
    setTimeout(() => {
      window.location.replace('https://maintenance.goklaim.com/');
    }, 3000);
  }
}
